export default __webpack_public_path__ + "static/media/logo.b4e50052.svg";